import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	scopeList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	scopeOption: {
		cursor: 'pointer',
	},
	scopeDisabled: {
		color: THEME.colors.text.light,
		cursor: 'not-allowed',
	},
	describedScope: {
		alignItems: 'flex-start',
	},
	describedScopeCheckbox: {
		marginTop: 1,
	},
	scopeDescription: {
		fontSize: THEME.typography.fontSizes.xs,
	},
});
